module.exports = {"component":"toast","status":"prod","display-name":"Toasts","last-accessibility-review":{"date-iso-8601":"2018/01/18","commit-sha":"ad6b6c6523ee21cada11be5f7ea4d99abc530726"},"SLDS-component-path":"/components/toast","dependencies":[{"component":"container"}],"url-slug":"toasts"}


//////////////////
// WEBPACK FOOTER
// ./components/toast/docs.json
// module id = 332
// module chunks = 0